import { useEffect } from 'react';
import i18n from '../i18n';
import { applyDocumentLanguage, getStoredLanguage } from '../i18n';

/**
 * Invitation page is Arabic-only and always RTL.
 * Restores the user's landing language preference when leaving the page.
 */
export const useInvitationPageLocale = (): void => {
    useEffect(() => {
        document.documentElement.lang = 'ar';
        document.documentElement.dir = 'rtl';

        return () => {
            const lang = getStoredLanguage();
            applyDocumentLanguage(lang);
            if (i18n.language !== lang) {
                i18n.changeLanguage(lang);
            }
        };
    }, []);
};
